
let config = {};
// if (process.env.NODE_ENV == 'production'||true) { 
//     config = {
//         baseUrl: 'https://cmeex.cc',
//         imgUrl: 'https://cmeex.cc/storage',
//         socketUrl: 'wss://cmeex.cc/ws1',
//         socketUrl1: 'wss://cmeex.cc/ws2',
//         pcUrl:'https://pc.cmeex.cc',
//         appName: '',
//         version: '1.0.0',
//         mobile: 'https://mobile.cmeex.cc',
//         down:"#"
//     };
// } else {
//     config = {
//         // baseUrl: 'https://oy.zetagl0bal.com',
//         // imgUrl: 'https://oy.zetagl0bal.com/upload',
//         // socketUrl: 'wss://oy.zetagl0bal.com:2346/',
//         // socketUrl1: 'wss://oy.zetagl0bal.com:2348/',
// 		baseUrl: 'https://cmeex.cc',
// 		imgUrl: 'https://cmeex.cc/storage',
// 		socketUrl: 'wss://cmeex.cc/ws1',
// 		socketUrl1: 'wss://cmeex.cc/ws2',
//         pcUrl:'https://pc.cmeex.cc',
//         appName: '本地开发',
//         version: '0.0.0',
//         mobile: 'https://mobile.cmeex.cc/'
//     }

// }

if (process.env.NODE_ENV == 'production'||true) { 
    config = {
        baseUrl: 'https://happyxfb.net',
        imgUrl: 'https://happyxfb.net/storage',
        socketUrl: 'wss://happyxfb.net/ws1',
        socketUrl1: 'wss://happyxfb.net/ws2',
        pcUrl:'https://pc.happyxfb.net',
        appName: '',
        version: '1.0.0',
        mobile: 'https://h5.happyxfb.net',
		cloudImg: 'https://images.shareimgs.com/',
        down:"#"
    };
} else {
    config = {
        // baseUrl: 'https://oy.zetagl0bal.com',
        // imgUrl: 'https://oy.zetagl0bal.com/upload',
        // socketUrl: 'wss://oy.zetagl0bal.com:2346/',
        // socketUrl1: 'wss://oy.zetagl0bal.com:2348/',
		 baseUrl: 'https://happyxfb.net',
		imgUrl: 'https://happyxfb.net/storage',
		socketUrl: 'wss://happyxfb.net/ws1',
		socketUrl1: 'wss://happyxfb.net/ws2',
		// pcUrl:'https://pc.503test.xyz',
        pcUrl:'https://pc.happyxfb.net',
        appName: '本地开发',
        version: '0.0.0',
        mobile: 'https://h5.happyxfb.net',
		cloudImg: 'https://images.shareimgs.com/',
    }

}


export default config;